<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e9ZHv7/OEBPS/images/9780312602765_cvi.png?1724535987991" alt="This image is the cover for the book Side Effects"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Side Effects
      </h1>
      <p class="bookDescription body article font2">
        <p>Serious, funny, compelling -- and unique: a novel about a teenager with cancer and doesn't die, from Amy Goldman Koss, acclaimed author of <i>THE GIRLS.</i><br/><br/>As if it isn't bad enough to have cancer, practically every time we pick up a book or hear about a character in a movie who gets sick, we know they'll be dead by the last scene. In reality, kids get all kinds of cancers, go through unspeakable torture and painful treatments, but walk away, fine in the end. <br/><br/>Isabelle, not quite 15, is living a normal life of fighting with her younger brother, being disgusted with her parents, and hoping to be noticed by a cute guy. Everything changes in an instant when she is diagnosed with lymphoma-- and even her best friend, Kay, thinks Izzy is going to die. But she doesn't, and her humor—sardonic, sharp, astute -- makes reading this book accessible and actually enjoyable.<br/><br/>From the acclaimed author of <i>The Girls</i> and <i>Poison Ivy</i>, <i>Side Effects</i> is about the pain, fear, and unlikely comedy of 15-year-old Izzy's journey, told in her own powerful and authentic voice. It is Izzy's story—screams and all.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amy Goldman Koss
      </h2>
      
      <p class="authorDescription body article"><P>Amy Goldman Koss is the author of <I>The Girls</I>, an ALA Best Book for Young Adults and Quick Picks selection, and <I>Poison Ivy</I>, called "fascinating and intriguing" by Publishers Weekly. She lives in Glendale, California.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Roaring Brook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d22c4cd